package theme
import androidx.compose.ui.graphics.Color

val primary = Color(0xFF00A54F)
val primaryLight = Color(0xFFAABFFD)
val secondary = Color(0xFFFF5E32)
val secondaryLight = Color(0xFFff9e84)
val red = Color(0xFFEC2121)
val redLight = Color(0xFFFEF1F1)
val tertiary = Color(0xFFF2A841)
val yellow = Color(0xFFFFBD4F)
val yellowLight = Color(0xFFFFF9F0)
val white = Color(0xFFFFFFFF)
val pink = Color(0xFFEC00C6)
val onboardingBg = Color(0xFFF6E6D9)
val listSeparator = Color(0xFFF2F2F2)
val grey = Color(0xFF94A3B8)
val greyLight = Color(0xFFF5F5F5)
val charcoal = Color(0xFF525251)
val black = Color(0xFF000000)
val appBg = Color(0xFFFAFAFA)
val grey400 = Color(0xFF737372)


